// MainFile.js
import React, { useEffect, useRef, useState } from "react";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DataGridTable from "../DataTable/DataGridTable";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { callApi } from "../../common/api";

const StartUpMainComponent = ({ children }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const rowData = await callApi("get", "startup/allStartupDeals");
    const data = rowData?.data?.response?.data?.response;
    const transformedResponse = data.map((item) => ({ ...item, _id: item.id }));
    setRows(transformedResponse);
  };

  const DropDownButton = (props) => {

const dropDownStatus={
    0:{
        backgroundColor:"#FFBBBA",
        buttonText:'Deactive',
        buttonTextColor:'#B51918',
    },
    1:{
        backgroundColor:"#C5DDBB",
        buttonText:'Active',
        buttonTextColor:'#316719',
    },
    2:{
        backgroundColor:"#F7ECBE",
        buttonText:'Draft',
        buttonTextColor:'#A38921',
    },
    3:{
        backgroundColor:"#C5E0FA",
        buttonText:'Send to Verify',
        buttonTextColor:'#306FA9',
    }
}

    const [anchorEl, setAnchorEl] = useState(null);
    const { rowData } = props;
    const [buttonColor, setButtonColor] = useState("");
    const [buttonTextColor, setButtonTextColor] = useState("");
    const [buttonText, setButtonText] = useState("");
const [status,setStatus]=useState('')
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    useEffect(() => {
        setStatus(props?.rowData?.row?.status)
      if (props?.rowData?.row?.status == "Draft") {
        setButtonColor("#F7ECBE");
        setButtonTextColor("#A38921");
        setButtonText("Draft");
      }
      if (props?.rowData?.row?.status == "Active") {
        setButtonColor("#C5DDBB");
        setButtonTextColor("#316719");
        setButtonText("Active");
      }
      if (props?.rowData?.row?.status == "Inactive") {
        setButtonColor("#FFBBBA");
        setButtonTextColor("#B51918");
        setButtonText("Deactive");
      }
      if (props?.rowData?.row?.status == "Send to Verify") {
        setButtonColor("#C5E0FA");
        setButtonTextColor("#306FA9");
        setButtonText("Send to Verify");
      }
    }, []);

    const handleClose = async (value) => {
      const id = props?.rowData?.row?._id;
      setStatus('Draft')
      const formData={
        id:id,
        status : value
      }
      const response = await callApi("put", "startup/updateDealStatus",formData);
    
      setAnchorEl(null);
      if(response.status){
        setButtonColor(dropDownStatus[value].backgroundColor)
        setButtonTextColor(dropDownStatus[value].buttonTextColor)
        setButtonText(dropDownStatus[value].buttonText)
      }
    };
    const MenuHandleClose = () => {
      setAnchorEl(null);
    };

    const menuStyle = {
      background: `${buttonColor}`, // Set your desired background color
      color: `${buttonTextColor}`, // Set your desired text color
    };
    return (
      <div>
        <Button
          sx={{
            width: "fit-content",
            height: "35px",
            color: `${buttonTextColor}`,
            borderColor: "white",
            backgroundColor: `${buttonColor}`,
            borderRadius: "0.5rem",
            "&:hover": {
              borderColor: "white",
              backgroundColor: `${buttonColor}`,
            },
          }}
          aria-controls="dropdown-menu"
          aria-haspopup="true"
          onClick={handleClick}
          variant="contained"
          color="primary"
        >
          {buttonText}{" "}
          <KeyboardArrowDownIcon sx={{ color: `${buttonTextColor}` }} />
        </Button>
        <Menu
          id="dropdown-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={MenuHandleClose}
          PaperProps={{ style: menuStyle }}
        >
          <MenuItem
            value="2"
            onClick={() => {
              handleClose(2);
            }}
          >
            Draft
          </MenuItem>
          <MenuItem
            value="1"
            onClick={() => {
              handleClose(1);
            }}
          >
            Active
          </MenuItem>
          <MenuItem
            value="0"
            onClick={() => {
              handleClose(0);
            }}
          >
            Deactive
          </MenuItem>
          <MenuItem
            value="3"
            onClick={() => {
              handleClose(3);
            }}
          >
            Send To Verify
          </MenuItem>
        </Menu>
      </div>
    );
  };
  const routeToDeal = (id) => {
    window.location.href = `/companyWall?id=${id}`;
  };

  const columns = [
    {
      field: "dealName",
      headerName: "Deal Name",
      width: 800,
      editable: false,
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      editable: false,
      renderCell: (rowData) => {
        return (
          <div>
            <DropDownButton rowData={rowData} />{" "}
          </div>
        );
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 200,
      editable: false,
      renderCell: (rowData) => {
        return (
          <div>
            <Button
              onClick={() => {
                routeToDeal(rowData?.row?._id);
              }}
            >
              <BorderColorIcon />
            </Button>
          </div>
        );
      },
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        backgroundColor: "black",
        position: "relative",
        height: "fit-content",
        // alignItems:"center",
        gap: "15px",
        paddingBottom: "20px",
      }}
    >
      <Box
        sx={{
          width: "95%",
          border: "1px solid", // Border outline
          display: "flex",
          flexDirection: "column",
          height: "fit-content",
          borderRadius: "5px",
          marginLeft: "38px",
          background: "#212121",
        }}
      >
        <DataGridTable
          height="100%"
          width="100%"
          data={rows || []}
          columns={columns}
        />
      </Box>
    </Box>
  );
};

export default StartUpMainComponent;
